import { render, staticRenderFns } from "./nav-bar-menu.vue?vue&type=template&id=1b36e680"
import script from "./nav-bar-menu.vue?vue&type=script&lang=ts"
export * from "./nav-bar-menu.vue?vue&type=script&lang=ts"
import style0 from "./nav-bar-menu.vue?vue&type=style&index=0&id=1b36e680&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VMenu})
